import { useGate, useStore, useStoreMap } from 'effector-react'
import {
  AccordionKeys,
  inspectionModel,
  QUERY_ACCORDION_KEY,
} from '~/entities/Inspection'
import { InspectionPhotoTypeEnum } from '~/shared/config/enums'
import { mapPhotoToImage } from '~/shared/ui/Gallery'
import { ArrowRightIcon } from '~/shared/ui/icons'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { myPalette } from '~/shared/ui/theme'
import { IconButton, TextButton, Button } from '../styled'

type LastInspectionButtonAuth = {
  inspectionId: UniqueId
}

export function LastInspectionButtonAuth({
  inspectionId,
}: LastInspectionButtonAuth) {
  useGate(inspectionModel.Gate, {
    id: inspectionId,
  })

  const inspectionPending = useStore(inspectionModel.requestFx.pending)
  const photos = useStoreMap(
    inspectionModel.$inspection,
    (inspections) => inspections?.getPhotos() || [],
  )

  const carPhotos = photos
    ?.filter((photo) => photo.type === InspectionPhotoTypeEnum.CAR)
    .map(mapPhotoToImage)

  if (!inspectionPending && !carPhotos?.length) return null

  return (
    <Button
      to={`inspections/${inspectionId}?${QUERY_ACCORDION_KEY}=${AccordionKeys.damages}`}
      variant='textLink'
      disabled={inspectionPending}
      contentProps={{ style: { padding: '0' } }}
    >
      <TextButton>Посмотреть фото</TextButton>
      <IconButton>
        {inspectionPending ? (
          <ProgressBlock size={16} color={myPalette.midnightBlue.main} />
        ) : (
          <ArrowRightIcon />
        )}
      </IconButton>
    </Button>
  )
}
